<template>
  <v-container grid-list-lg fluid>
    <v-row row wrap>
      <v-col cols="12" sm="12" md="4">
        <v-row>
          <v-col cols="12" sm="12">
            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Note
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="checkRightStatus(36)" small color="info" dark class="mr-2" @click="updateNote()" fab text>
                  <v-icon>save</v-icon>
                </v-btn>
                <div v-if="checkRightStatus(37)">
                  <span class="mr-2">Alert</span>
                  <toggle-button @change="updateAlert" :labels="true" v-if="Donor" color="red" v-model="Donor.alert"
                    :value="Donor.alert" :sync="true"></toggle-button>
                </div>
              </v-toolbar>
              <v-card-text>
                <v-textarea v-model="note" outlined hide-details label="Donor Note"></v-textarea>

                <!-- <div v-if="Donor && Donor.note">{{ Donor.note }}</div> -->
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12">
            <!-- <PaymentMethod ref="paymentMethodComponent" type="donor" /> -->
            <PaymentMethod ref="paymentMethodComponent" type="donor" :customer="Donor" />

            <!-- <v-select dense outlined :items="MerchantAccount" v-model="selectedMerchant" return-object item-text="name"
              label="Select Default Account"></v-select>
            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Payment Method
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <CreditCard v-if="cards.length === 0" :Cards="cards" @getCard="getCard" :donor="Donor" @submit="reload">
                </CreditCard>
              </v-toolbar>
              <div v-if="Donor.payCompassId">
                <v-progress-linear v-if="isLoading" size="50" width="7" indeterminate="indeterminate"
                  color="pink"></v-progress-linear>
                <v-list dense v-if="!isLoading">
                  <template v-for="(card, index) in cards">
                    <v-list-item :key="index">
                    
                      

                      <v-list-item-content>
                        <v-list-item-title>
                          <span v-if="card.card_type">{{ card.card_type }}</span><span v-if="card.account_type">{{
                            card.account_type }}</span> - {{ card.last4 }} <span class="text-capitalize">- {{
                              card.payment_method_type }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle><span v-if="card.expiry_month">{{ card.expiry_month }}/{{ card.expiry_year
                            }}- </span>
                          <span>{{ card.created_at | moment("L") }}</span></v-list-item-subtitle>
                      </v-list-item-content>
                      
                      
                      <v-list-item-action>
                        <v-menu bottom right offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon>
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                          </template>
                          <v-list class="menu-button">
                            <v-list-item @click="deleteCard(card)">
                              <v-list-item-title>Delete</v-list-item-title>
                            </v-list-item>
                            
                            
                          </v-list>
                        </v-menu>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list>
              </div>

            </v-card> -->

          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="8" v-if="Donor">
        <Comment :RelationId="Donor" :TypeId="5" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import donorService from "../service";
const Comment = () => import("@/modules/Comment/components/List");
import PaymentMethod from "@/modules/PaymentMethod/components/List.vue"
// const CreditCard = () => import("@/modules/Donors/components/CreditCard.vue");
// import payCompassService from "@/modules/PayCompass/service.js";
// import donationCategoryService from "@/modules/DonationCategory/service.js";
// import SaleRep from "@/modules/User/components/AutoComplete.vue"
// import PaymentPie from "@/modules/Customer/Payment/Chart/PaymentMethodPie";

export default {
  name: "donor-dashboard",
  props: ['Donor'],
  data() {
    return {
      // selectedMerchant: null,
      // MerchantAccount: [],
      // isLoading: false,
      loading: false,
      // cards: [],
      note: null,
      selectedUser: null,
    };
  },
  computed: {
    // ...mapGetters("customer", ["Donor"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus", 'currentBusiness']),
  },
  components: {
    // CreditCard,
    Comment,
    PaymentMethod,
    // SaleRep
  },
  watch: {
    // selectedMerchant(val) {
    //   // console.log('val', val)
    //   // console.log('customer', this.getCustomer)
    //   if (val) {
    //     // this.cards = []
    //     this.getCard()
    //   }

    // },
  },
  // async created() {
  //   await this.getDonationCategoryList()
  //   this.getCard()
  // },
  methods: {
    // getDonationCategoryList() {
    //   return donationCategoryService.getAll().then((response) => {
    //     console.log('response merchant', response)
    //     this.MerchantAccount = response.data;
    //     this.MerchantAccount.map(row => {
    //       // console.log('currentBusiness', this.currentBusiness)
    //       if (row.id === this.currentBusiness.DefaultDonationId) {
    //         // console.log('row selectedMerchant', row)
    //         this.selectedMerchant = row
    //       }
    //     })
    //   });
    // },
    // deleteCard(card) {
    //   this.$swal({
    //     title: "Are you sure?",
    //     text: "You won't be able to revert this!",
    //     icon: "question",
    //     showCancelButton: true,
    //     confirmButtonColor: "#B71C1C",
    //     cancelButtonColor: "#43A047",
    //     cancelButtonText: "No",
    //     confirmButtonText: "Yes",
    //   }).then((result) => {
    //     if (result.value) {
    //       payCompassService.deleteCard(card.id).then(result => {
    //         console.log('result', result)
    //         this.$swal
    //           .mixin({
    //             toast: true,
    //             position: "top-end",
    //             showConfirmButton: false,
    //             timer: 3000,
    //           })
    //           .fire({
    //             icon: "success",
    //             title: "Card was remove from the file",
    //           });
    //         this.reload()
    //       })
    //     }
    //   });

    // },
    // getCard() {
    //   this.cards = []
    //   console.log('get card', this.selectedMerchant.id, this.Donor)
    //   let payCompassId = null
    //   this.Donor.MerchantCustomers.map(row => {
    //     if (row.DonationCategoryId === this.selectedMerchant.id) {
    //       payCompassId = row.payCompassId
    //     }
    //   })
    //   if (payCompassId) {
    //     payCompassService.getAllCard(payCompassId, { donationCategoryId: this.selectedMerchant.id }).then(response => {
    //       console.log('card response', response)
    //       this.cards = response.data
    //       this.isLoading = false
    //     }).catch(error => {
    //       console.log('error', error)
    //       this.isLoading = false
    //     })
    //   }

    // },
    // async reload() {
    //   this.isLoading = true
    //   this.getCard()
    // },
    updateNote() {
      let data = {
        note: this.note,
      };
      this.updateCustomer(data);
    },
    updateAlert(val) {
      let data = {
        alert: val.value,
      };
      this.updateCustomer(data);
    },
    updateSaleman(val) {
      let data = {
        SalesRepUserId: val.id
      };
      this.updateCustomer(data);
    },
    updateCustomer(data) {
      return donorService.update(this.Donor.id, data).then((result) => {
        console.log('result', result)
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Update Successfully",
          });
        this.setCustomer(this.Donor.id);
      });
    },
  },
};
</script>
